import { render, staticRenderFns } from "./BrowseList.vue?vue&type=template&id=2d5fbac4&scoped=true"
import script from "./BrowseList.vue?vue&type=script&lang=js"
export * from "./BrowseList.vue?vue&type=script&lang=js"
import style0 from "./BrowseList.vue?vue&type=style&index=0&id=2d5fbac4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5fbac4",
  null
  
)

export default component.exports